import * as React from 'react';
import { useDynamicPhone } from './useDynamicPhone';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
/**
 * DynamicPhone
 * @param {string} formattedPhone - fallback знычение для телефона
 * @param {number} siteBlockId - уникальное значение для получение телефона
 * @param {IHttpApi} httpApi - инстанс для выполения запроса
 * @param {ILogger} logger - инстанс для логгирования
 * @param {EPageTypes} pageType - тип страницы
 * @param {EPlatformTypes} platformType - тип платформы
 * @param {string} placeType - произвольная строка позволяющая однозначно определить кнопку на странице
 * @param {number} announcementId - id объявления
 * @param {string} queryString
 */

export var DynamicPhone = function DynamicPhone(_ref) {
  var formattedPhone = _ref.formattedPhone,
    siteBlockId = _ref.siteBlockId,
    httpApi = _ref.httpApi,
    logger = _ref.logger,
    placeType = _ref.placeType,
    pageType = _ref.pageType,
    platformType = _ref.platformType,
    announcementId = _ref.announcementId,
    queryString = _ref.queryString,
    loader = _ref.loader;
  var _useDynamicPhone = useDynamicPhone({
      formattedPhone: formattedPhone,
      siteBlockId: siteBlockId,
      httpApi: httpApi,
      logger: logger,
      placeType: placeType,
      pageType: pageType,
      platformType: platformType,
      announcementId: announcementId,
      queryString: queryString
    }),
    dynamicPhone = _useDynamicPhone.dynamicPhone,
    responseEnded = _useDynamicPhone.responseEnded;
  if (!responseEnded && loader) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: loader
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: dynamicPhone
  });
};